import Zones                    from 'scripts/defa/zones/collection-zones';
import ManualZoneForm           from 'scripts/defa/zones/manual-zone-form';
import ZoneAlertsForm           from 'scripts/defa/zones/view-zone-alert-form';
import ZoneAliasForm            from 'scripts/defa/zones/view-zone-alias-form';
import ZoneForm                 from 'scripts/defa/zones/view-zone-form';
import ZonePresetForm           from 'scripts/defa/zones/view-zone-preset-form';
import Thermostat               from 'scripts/defa/zones/model-thermostat';
import TemperatureConfiguration from 'scripts/defa/zones/model-temperature-configuration';
import OnOff                    from 'scripts/defa/zones/model-on-off';
import HeatingZone              from 'scripts/defa/zones/model-heating-zone';
import DutyCycle                from 'scripts/defa/zones/model-duty-cycle';
import Basic                    from 'scripts/defa/zones/model-basic';

import Zone                     from 'scripts/defa/zones/model-zone';
import ZoneCollectionView       from 'scripts/defa/zones/view-zone-collection-view';
import ZoneMenuView             from 'scripts/defa/zones/view-zone-menu-view';
import ZoneModeForm             from 'scripts/defa/zones/view-zone-mode-form';
import ZonePanelContainer       from 'scripts/defa/zones/view-zone-panel-container';
import ZoneView                 from 'scripts/defa/zones/view-zone-view';
import Module                   from 'scripts/module';

const ZonesModule = new Module( 'ZonesModule', {
	collections: {
		Zones
	},
	models     : {
		Zone,
		Basic,
		DutyCycle,
		HeatingZone,
		OnOff,
		Thermostat,
		TemperatureConfiguration,
		
	},
	views      : {
		ZoneAlertsForm,
		ZoneAliasForm,
		ZoneCollectionView,
		ZoneForm,
		ZonePresetForm,
		ZoneView,
		ManualZoneForm,
		ZoneMenuView,
		ZoneModeForm,
		ZonePanelContainer,
	}
} );

export default ZonesModule;
